{
  "app_loading": "Verbinding met schuilplaatsnetwerk...",
  "layout_brand": "NederFall",
  "layout_subtitle": "Schuilplaats",
  "nav_hub": "Hub",
  "nav_people": "Mensen",
  "nav_trips": "Tochten",
  "nav_stash": "Voorraad",
  "nav_quests": "Dagboek",
  "auth_intro": "Het is 2040 in Nederland. De overheid is gevallen en de samenleving is vervallen. De meeste mensen zijn weg, maar diegenen die overblijven proberen te overleven in de harde omgeving die is overblijven van wat ooit een welvarend land was met cultuur en traditie.",
  "auth_description": "Voortgang wordt opgeslagen in je account.",
  "auth_google": "Verder met Google",
  "auth_redirecting": "Doorsturen...",
  "account_back": "Terug",
  "account_header_account": "Account",
  "account_logged_in_as": "Ingelogd als",
  "account_google_hint": "Accountbeheer via Google vind je in je Google-accountinstellingen.",
  "account_sync_title": "Cloud-sync",
  "account_status_label": "Status:",
  "account_status_error_prefix": "Fout:",
  "account_status_ok": "Actief",
  "account_status_syncing": "Bezig...",
  "account_last_sync": "Laatste sync:",
  "account_never_synced": "Nog niet gesynchroniseerd",
  "account_upload": "Upload wijzigingen",
  "account_pull_cloud": "Opnieuw van cloud",
  "account_settings_title": "Instellingen",
  "account_language": "Taal",
  "account_language_note": "Schakel tussen Nederlands en Engels voor de hele interface en spelteksten (items, locaties, gebeurtenissen, enz.).",
  "account_lang_nl": "Nederlands",
  "account_lang_en": "English",
  "account_notifications": "Meldingen",
  "account_notifications_desc": "Web push wanneer expedities terugkeren (ook als de app op de achtergrond staat).",
  "account_notifications_blocked": "Meldingen konden niet worden ingeschakeld. Controleer browser- of toestemmingen.",
  "account_sound": "Geluid",
  "account_sound_desc": "Korte geluiden bij acties en expedities.",
  "account_theme": "Thema",
  "account_theme_desc": "Schakel naar licht thema.",
  "account_help_title": "Help",
  "account_help_1": "Stuur overlevenden op tochten via het tabblad Tochten.",
  "account_help_2": "Voorraden en werkstations vind je op Hub en Voorraad.",
  "account_help_3": "Bij problemen met sync: probeer \"Opnieuw van cloud\" of log opnieuw in.",
  "account_about_title": "Over",
  "account_about_body": "NederFall: Hideout — proof of concept. Zie README in het project voor meer.",
  "account_sign_out": "Afmelden",
  "account_header_btn": "Account",
  "account_btn_title": "Account en instellingen",
  "hideout_stat_idle": "Stand-by",
  "hideout_stat_missions": "Onderweg",
  "hideout_stat_lowest": "Laagste",
  "hideout_workstations": "Werkstations",
  "hideout_build_card_title": "Werkstations bouwen",
  "hideout_build_card_sub": "Gebruikt voorraad · tik voor opties",
  "hideout_build_card_count": "{{count}} nog te bouwen",
  "hideout_build_card_available": "{{count}} te bouwen beschikbaar",
  "hideout_build_ready_hint": "Genoeg materiaal om minstens één station te bouwen",
  "hideout_build_ready_chip": "Klaar",
  "hideout_build_ready_badge": "{{count}} klaar",
  "hideout_build_modal_title": "Werkstation bouwen",
  "hideout_build_modal_hint": "Kosten worden uit je voorraad betaald bij bevestigen.",
  "hideout_build_modal_empty": "Hier valt niets meer te bouwen.",
  "hideout_quick": "Snel",
  "hideout_send_out": "Stuur erop uit",
  "hideout_survivors": "Overlevenden",
  "hideout_ready_suffix": "klaar",
  "hideout_total_suffix": "totaal",
  "hideout_flavor": "De schuilplaats kraakt. Niemand zegt het, maar iedereen wacht op iets dat niet komt.",
  "hideout_flavor_neutral_01": "Regen tikt op het plaatwerk in een ritme waar niemand doorheen praat.",
  "hideout_flavor_neutral_02": "Iemand heeft dezelfde bout vandaag twee keer aangedraaid. Hij ratelt nog steeds.",
  "hideout_flavor_neutral_03": "Je luistert naar vleugels of banden—alles wat zegt dat de wereld bewoog.",
  "hideout_flavor_food_low_01": "We zijn bijna door het eten heen. Porties zweven rond beleefd fictie.",
  "hideout_flavor_food_low_02": "De blikken voelen elke ochtend lichter; niemand vraagt wat er nog is.",
  "hideout_flavor_water_low_01": "Het water raakt op—lege flessen staan als slechte voortekenen.",
  "hideout_flavor_water_low_02": "Het water tikt naar beneden; stemmen blijven voorzichtig bij de kan.",
  "hideout_flavor_food_high_01": "Even voelt de voorraad genereus—eten gestapeld als kleine overwinningen.",
  "hideout_flavor_food_high_02": "Vanavond genoeg blikken; je merkt dat je ontspant bij het rek.",
  "hideout_flavor_water_high_01": "Water is nu geen zorg—er is genoeg om te delen zonder te tellen.",
  "hideout_flavor_water_high_02": "Jerrycans en flessen in de rij; dorst voelt vandaag ver weg.",
  "hideout_flavor_solo_01": "Alleen hier antwoordt elk geluid dubbel.",
  "hideout_flavor_solo_02": "Eenzaamheid is niet stil—die stelt vragen hardop.",
  "hideout_flavor_duo_01": "Twee overlevenden nu; het voelt bijna alsof je een vriend hebt gevonden.",
  "hideout_flavor_duo_02": "Gezelschap verandert de rekensom—wacht, maaltijd, hoop middendoor.",
  "hideout_flavor_rural_map_01": "Je begint je buiten een beetje te vinden—de paden voelen vertrouwd.",
  "hideout_flavor_rural_map_02": "Ten zuiden van de rivier is geen waas meer; herkenningspunten blijven hangen.",
  "hideout_flavor_den_bosch_01": "Den Bosch gaat open—je bereik reikt naar langere straten.",
  "hideout_flavor_den_bosch_02": "De rand van de stad is niet meer hypothetisch; routes bijten dieper naar binnen.",
  "hideout_flavor_bike_01": "Een fiets in het rek verandert afstand—je ziet jezelf tussen patrouilles glijden.",
  "hideout_flavor_bike_02": "Twee wielen laten smoesjes verdwijnen; klussen klinken opeens haalbaar.",
  "hideout_flavor_car_01": "Sleutels aan een haak die niet mag bestaan—een auto verandert hoe ver \"ver\" is.",
  "hideout_flavor_car_02": "Metalen schil en benzinelucht: gevaarlijke luxe, echte mobiliteit.",
  "hideout_flavor_pair_01": "{{a}} en {{b}} bekvechten zacht over wachturen—vertrouwen met scherpe timing.",
  "hideout_flavor_pair_02": "{{a}} wisselde een mop met {{b}}; het lachen duurde langer dan gepland.",
  "hideout_flavor_pair_03": "{{a}} checkt de uitrusting van {{b}} zonder te vragen; gewoontes synchroon als tandwielen.",
  "hideout_flavor_pair_04": "{{b}} leende {{a}} droge sokken—kleine solidariteit, luid stil.",
  "hideout_flavor_gaming_01": "{{name}} staart naar dode stopcontacten en mist hun oude console.",
  "hideout_flavor_gaming_02": "{{name}} beschrijft een speedrun als schriftuur—spiiergeheugen zonder hardware.",
  "hideout_flavor_gaming_03": "{{name}} neuriet een baasthema bij het stapelen van schroot; oude reflexen sterven hard.",
  "exp_heading_active": "Onderweg",
  "exp_none_caption": "Niemand is op pad. De stad wacht.",
  "exp_remaining_one": "Nog {{count}} tocht",
  "exp_remaining_many": "Nog {{count}} tochten",
  "exp_progress": "{{done}}/{{need}} tochten voltooid",
  "exp_no_survivors": "Niemand beschikbaar",
  "exp_send_out": "Trip starten",
  "exp_slots_full": "Alle tripplekken bezet",
  "exp_send_disabled_idle": "Niemand op standby — check Personen of wacht op terugkeer.",
  "exp_send_disabled_full": "Alle expeditieplekken bezet — rond eerst trips af.",
  "exp_possible_loot": "Mogelijke buit",
  "exp_exploration": "Verkenning",
  "exp_exploration_unexplored": "Onverkend",
  "exp_exploration_fully_explored": "Volledig verkend",
  "exp_den_bosch_quest_gate_hint": "Open je Questlog en start De weg naar de stad om Den Bosch te ontdekken. Na voltooiing verschijnt je eerste bestemming.",
  "surv_title": "Overlevenden",
  "surv_roster_cap": "{{current}}/{{max}} capaciteit",
  "surv_hint": "Tik iemand aan voor zijn dossier.",
  "stash_empty": "De voorraadkamer is leeg. Stuur iemand op pad.",
  "stash_trinkets": "Snuisterijen",
  "stash_total_value": "Totale waarde:",
  "stash_points": "pt",
  "assign_send_title": "Stuur {{name}} op pad",
  "assign_pick_destination": "Kies een bestemming. De tocht kost kracht.",
  "assign_cancel": "Annuleer",
  "assign_send": "Sturen",
  "assign_loot_yield_pct": "{{sign}}{{pct}}% extra buit",
  "vehicle_loot_pct": "{{sign}}{{pct}}% buit",
  "assign_who_goes": "Wie gaat naar {{place}}?",
  "assign_no_idle": "Niemand staat klaar. Iedereen is ergens mee bezig.",
  "assign_at_workstation": "Toegewezen aan {{name}}",
  "assign_recruit_retry_hint": "Je hebt hier al eerder een overlevende tegengekomen. Wil je proberen ze opnieuw te vinden?",
  "assign_recruit_retry_toggle": "Zoek {{name}} opnieuw",
  "status_working": "Aan het werk",
  "assign_needs_line": "{{hunger}} {{hungerVal}} · {{thirst}} {{thirstVal}} · {{energy}} {{energyVal}}",
  "ws_sheet_all_away": "Iedereen is op pad.",
  "ws_sheet_injured": "Gewond",
  "ws_sheet_heal_note": "Verband aanleggen → Idle",
  "toast_back": "{{name}} terug",
  "toast_nothing": "niets gevonden",
  "exp_card_away": "{{name}} onderweg",
  "exp_card_unknown": "???",
  "gems_label": "Kristallen",
  "exp_skip_half_time_title": "Gebruik 1 kristal om de helft van de wachttijd over te slaan",
  "explore_to_reveal": "Verkennen om te ontdekken",
  "event_heading": "Gebeurtenis",
  "workstation_available": "{{count}} beschikbaar",
  "workstation_insufficient": "Onvoldoende",
  "workstation_locked": "Vergrendeld",
  "workstation_unbuilt": "Niet gebouwd",
  "workstation_cost_line": "−1 {{cat}} · +{{restore}} {{need}}",
  "cat_food_short": "voedsel",
  "cat_water_short": "water",
  "cat_scrap_short": "schroot",
  "cat_weapon_short": "wapen",
  "cat_meds_short": "medicijnen",
  "cat_trinket_short": "snuisterij",
  "need_hunger_short": "honger",
  "need_thirst_short": "dorst",
  "need_energy_short": "energie",
  "need_hunger": "Honger",
  "need_thirst": "Dorst",
  "need_energy": "Energie",
  "moral_delta": "Energie",
  "assign_cost_hunger": "Honger −{{v}}",
  "assign_cost_thirst": "Dorst −{{v}}",
  "assign_cost_energy": "Energie {{v}}",
  "status_idle": "Stand-by",
  "status_onmission": "Onderweg",
  "status_injured": "Gewond",
  "status_resting": "Rust uit",
  "role_scavenger": "Sjacheraar",
  "role_medic": "Hulpverlener",
  "role_cook": "Kok",
  "equipment_weapon": "Wapen",
  "equipment_tool": "Gereedschap",
  "equipment_empty_hands": "Lege handen",
  "equipment_no_tool": "Geen gerei",
  "resource_strip_food": "Voedsel",
  "resource_strip_water": "Water",
  "resource_strip_scrap": "Schroot",
  "resource_strip_meds": "Med.",
  "resource_strip_survivors": "Ploeg",
  "skill_stealth": "Sluw",
  "skill_note_looting": "Vindt meer buit op tochten.",
  "skill_note_stealth": "Bespaart energie onderweg.",
  "skill_note_endurance": "Bespaart honger en dorst onderweg.",
  "skill_guns": "Vuurwapens",
  "skill_melee": "Melee",
  "skill_heavy_weapons": "Zware wapens",
  "skill_explosives": "Explosieven",
  "skill_archery": "Boogschieten",
  "skill_cybernetics": "Cybernetica",
  "skill_looting": "Plunderen",
  "skill_first_aid": "Eerste hulp",
  "skill_survival": "Overleving",
  "skill_endurance": "Uithouding",
  "skill_animal_training": "Dierentraining",
  "skill_navigation": "Navigatie",
  "skill_fishing": "Vissen",
  "skill_climbing": "Klimmen",
  "skill_parkour": "Parkour",
  "skill_swimming": "Zwemmen",
  "skill_lockpicking": "Lockpicking",
  "skill_programming": "Programmeren",
  "skill_engineering": "Engineering",
  "skill_electronics": "Elektronica",
  "skill_tinkering": "Knutselen",
  "skill_bartering": "Handelen",
  "skill_persuasion": "Overtuiging",
  "skill_linguistics": "Talen",
  "skill_charisma": "Charisma",
  "skill_construction": "Bouwkunde",
  "skill_crafting": "Maken",
  "skill_cooking": "Koken",
  "skill_agriculture": "Landbouw",
  "skill_gaming": "Gaming",
  "skill_art": "Kunst",
  "skill_music": "Muziek",
  "skill_driving": "Rijden",
  "onboarding_continue": "Verder",
  "onboarding_survivor_label": "Overlevende",
  "cc_title": "Jouw overlevende",
  "cc_blurb": "Geef een naam en verdeel zes bonuspunten over kernvaardigheden voordat het verhaal verdergaat.",
  "cc_name_label": "Naam",
  "cc_name_placeholder": "Naam van overlevende",
  "cc_portrait_label": "Portret",
  "cc_gender_label": "Weergave",
  "cc_gender_unspecified": "Zeg ik liever niet",
  "cc_gender_female": "Vrouw",
  "cc_gender_male": "Man",
  "cc_gender_nonbinary": "Non-binair",
  "cc_skills_title": "Attributen",
  "cc_points_remaining": "{{count}} punten over",
  "cc_skip_intro": "Je hebt al een team. Doorgaan naar de intro zonder het team te wijzigen?",
  "cc_skip_continue": "Verder naar intro",
  "account_replay_tutorial": "Tutorial opnieuw spelen",
  "account_reset_section": "Gevaarzone",
  "account_reset_hint": "Wis alle voortgang van de schuilplaats op dit apparaat en in de cloud. Je login en taal blijven behouden.",
  "account_reset_first": "Voortgang wissen",
  "account_reset_confirm_prompt": "Tik nogmaals om te bevestigen. Dit kan niet ongedaan worden gemaakt.",
  "account_reset_final": "Voortgang gewist",
  "account_reset_cancel": "Annuleren",
  "account_install_app_title": "App installeren",
  "account_install_app_button": "Installeren op dit apparaat",
  "account_install_app_desc": "Voeg dit spel toe aan je startscherm voor een volledig scherm zonder adresbalk.",
  "account_install_app_unavailable": "Al geïnstalleerd of niet ondersteund door deze browser.",
  "coach_label": "Coach",
  "coach_first_trip_title": "Eerste tocht",
  "coach_first_trip_body": "Ga naar Tochten en stuur iemand naar Brug naar Vinkel. Die eerste run is extra kort.",
  "coach_first_return_title": "Wacht op terugkeer",
  "coach_first_return_body": "Je eerste expeditie duurt ongeveer 20 seconden. Zodra de toast verschijnt, gaat de tutorial door.",
  "coach_workstation_title": "Gebruik een werkstation",
  "coach_workstation_body": "Check de toast en je voorraad. Open Keuken of Putwater in de Hub en verzorg iemand.",
  "coach_cta_understood": "Begrepen",
  "coach_cta_waiting": "Ik wacht",
  "coach_cta_continue": "Doorgaan",
  "quests_heading": "Questlog",
  "quests_intro": "Verhalen met taken. Sommige quests geven beloningen of ontgrendelen later iets — andere zijn puur overleven.",
  "quests_collapsed_objectives": "{{done}}/{{total}} doelen",
  "quests_collapsed_complete_short": "Voltooid",
  "quests_starter_tag": "Overleven",
  "quest_starter_survival_title": "De eerste nacht halen",
  "quest_starter_survival_body": "Niemand gaf je een briefing — alleen natte modder en lege rugzakken. Neem eerst de Brug-tocht, kom terug met iets, bouw het Kampvuur (keuken), en voed dan iemand.",
  "quest_starter_inactive": "Beschikbaar na de openingsbeelden.",
  "quest_starter_complete": "Je hebt de basis gehaald. De schuilplaats onthoudt het.",
  "quest_starter_reward": "Beloning: 20 kristallen.",
  "quest_phase_send_bridge": "Stuur iemand naar Brug naar Vinkel (tab Tochten). De eerste run is kort.",
  "quest_phase_return_loot": "Wacht tot ze terug zijn met spullen.",
  "quest_phase_build_campfire": "Bouw het Kampvuur-keukenwerkstation in de Hub.",
  "quest_phase_feed_hunger": "Gebruik het Kampvuur met voedsel om iemands honger te verlichten.",
  "quests_den_bosch_tag": "Gateway",
  "quest_den_bosch_gateway_title": "De weg naar de stad",
  "quest_den_bosch_gateway_body": "Rurale Zuid is uitgekaart — Den Bosch wacht erachter. Laat zien dat je genoeg voorraden hebt voordat je de stad ingaat.",
  "quest_den_bosch_gateway_start_hint": "Doelen tellen pas nadat je bent begonnen — tik op Start als je er klaar voor bent.",
  "quest_start_button": "Quest starten",
  "quest_den_bosch_obj_farm": "Voltooi een tocht naar de verlaten boerderij ({{current}} / {{need}})",
  "quest_den_bosch_obj_food": "Verzamel {{need}} voedselwaarde uit expeditie-buit na het starten ({{current}} / {{need}})",
  "quest_den_bosch_obj_water": "Verzamel {{need}} watervaarde uit expeditie-buit na het starten ({{current}} / {{need}})",
  "quest_den_bosch_obj_farm_label": "Tocht naar verlaten boerderij",
  "quest_den_bosch_obj_food_label": "Voedselwaarde uit expeditie-buit",
  "quest_den_bosch_obj_water_label": "Watervaarde uit expeditie-buit",
  "quest_den_bosch_gateway_complete": "De rand van de stad ligt open.",
  "quest_den_bosch_gateway_reward": "Je eerste bestemming in 's-Hertogenbosch staat nu onder Tochten.",
  "quests_utrecht_tag": "Utrecht",
  "quest_utrecht_gateway_title": "Noordelijke corridor — Utrecht",
  "quest_utrecht_gateway_body": "De snelweg naar het noorden is een gok: je hebt een sterkere schuilplaats en een werkend signaal nodig voordat Utrecht opengaat. Pak het stap voor stap.",
  "quest_utrecht_gateway_start_hint": "Tik op Start als je klaar bent — doelen komen één voor één. De vier binnenstadslocaties van Den Bosch moeten eerst volledig verkend zijn.",
  "quest_utrecht_phase_find_radio": "Vind een overlevingsradio",
  "quest_utrecht_phase_find_radio_detail": "Je kamp is nog te stil. Verken de A2-corridor en sloop een kapotte radio bij de ingestorte tankplaats — je hebt onderdelen nodig voordat iemand antwoordt.",
  "quest_utrecht_phase_repair_radio": "Repareer de radio in de Werkplaats",
  "quest_utrecht_phase_repair_radio_detail": "Gebruik het werkplaatsrecept dat scrap-radio-broken omzet in een werkende scrap-radio (draad en elektronica helpen).",
  "quest_utrecht_phase_build_broadcast": "Bouw het zendstation",
  "quest_utrecht_phase_build_broadcast_detail": "Richt het zendstation op — de eerste bouw verbruikt je werkende scrap-radio en koppelt de mast aan het netwerk.",
  "quest_utrecht_phase_north_supply": "Bereik uit en slep spullen naar het noorden",
  "quest_utrecht_phase_north_supply_detail": "Met de mast live: recruteer meer overlevenden via de zender, en haal daarna schroot en elektronica binnen via expedities voor de duw richting Utrecht.",
  "quest_utrecht_obj_broadcast_label": "Bouw het zendstation",
  "quest_utrecht_obj_recruit_label": "Recruteer overlevenden (geen Trader-recruits)",
  "quest_utrecht_obj_scrap_label": "Schrootwaarde na zender",
  "quest_utrecht_obj_electronics_label": "Elektronicawaarde na zender",
  "quest_utrecht_gateway_complete": "Utrecht staat op de kaart.",
  "quest_utrecht_gateway_reward": "Domplein staat onder Tochten — de grachtenketen ontgrendelt daar.",
  "exp_a2_quest_gate_hint": "Open Dagboek → start de Utrecht-corridorquest om de snelweg te openen.",
  "exp_utrecht_quest_gate_hint": "Voltooi de Utrecht-corridorquest om de stad te openen.",
  "role_trader": "Handelaar",
  "ws_detail_market_section": "Handelsrun",
  "ws_detail_market_blurb": "Wijs een Handelaar toe en start een getimede route voor Stash €. Tik opnieuw als de timer klaar is om te innen.",
  "ws_detail_market_run": "Start handelsrun",
  "ws_detail_market_running": "Handelaar onderweg…",
  "ws_detail_market_claim": "Uitbetaling innen",
  "ws_detail_training_section": "Trainingsplein",
  "ws_detail_training_blurb": "Wijs iemand toe die vrij is en start een uithoudingsronde. XP komt automatisch als de timer afloopt.",
  "ws_detail_training_start": "Start trainingsronde",
  "ws_detail_training_running": "Trainen… nog {{time}}",
  "ws_detail_computer_section": "Terminalslots",
  "ws_detail_computer_blurb": "Plaats gesloopte hardware per slot, wijs een operator toe en start een hackklus. Stash € en elektronica komen automatisch als elke timer afloopt.",
  "ws_detail_computer_slot_label": "Slot {{n}}",
  "ws_detail_computer_hardware": "Hardware",
  "ws_detail_computer_slot_empty": "Lege werkplek",
  "ws_detail_computer_operator": "Operator",
  "ws_detail_computer_no_operator": "Niemand",
  "ws_detail_computer_start": "Start hackklus",
  "ws_detail_computer_running": "Bezig… nog {{time}}",
  "recipes_title": "Recepten",
  "recipes_active_job": "Er loopt al een craft op dit station.",
  "recipes_unlock_at": "Ontgrendelt na {{count}} voltooide expedities",
  "recipes_close": "Sluiten",
  "stash_filter_all": "Alles",
  "stash_filter_food": "Voedsel",
  "stash_filter_water": "Water",
  "stash_filter_meds": "Med",
  "stash_filter_scrap": "Schroot",
  "stash_filter_weapons": "Wapens",
  "stash_filter_trinkets": "Snuisterijen",
  "stash_search_placeholder": "Zoek item...",
  "stash_sort_rarity": "zeldzaamheid",
  "stash_sort_name": "naam",
  "stash_sort_quantity": "aantal",
  "stash_capacity_label": "Voorraadcapaciteit",
  "stash_capacity_warning": "Stapels {{current}} / {{cap}} — maak ruimte of verbeter opslag.",
  "stash_keep": "Bewaar",
  "stash_keep_locked": "Bewaard",
  "stash_use": "Gebruik",
  "stash_use_feed_title": "Voed met {{item}}",
  "stash_use_hydrate_title": "Geef water met {{item}}",
  "stash_use_treat_title": "Behandel met {{item}}",
  "stash_use_less_effect_note": "Gebruik vanuit de voorraad geeft minder effect dan verzorging via werkstations.",
  "stash_use_food_effect_note": "Voedsel uit de voorraad geeft minder verzadiging dan bij een kampvuur of keuken.",
  "stash_use_water_effect_note": "Water uit de voorraad geeft minder verzadiging dan bij een waterpunt.",
  "stash_use_meds_effect_note": "Medicijnen uit de voorraad werken alleen bij gewonde overlevenden (wond verwijderen).",
  "stash_weapon_equip_title": "Uitrusten: {{item}}",
  "stash_weapon_equip_note": "Kies wie dit wapen moet uitrusten.",
  "stash_weapon_current": "Huidig",
  "stash_weapon_damage_change": "{{current}} -> {{next}} schade",
  "stash_drop": "Drop",
  "stash_discard_selected": "Verwijder selectie ({{count}})",
  "stash_detail_rarity": "Zeldzaamheid",
  "stash_detail_category": "Categorie",
  "stash_detail_value": "Waarde",
  "stash_balance": "Saldo",
  "surv_profile_progress": "Profielprogressie",
  "surv_xp_line": "XP {{current}}/{{required}}",
  "surv_achievements": "{{count}} mijlpalen",
  "detail_extra_skills": "Geleerde extra vaardigheden",
  "detail_skill_books": "Boeken en manuals",
  "detail_no_skill_books": "Geen skillboeken in voorraad.",
  "detail_learn_skill": "Leer {{skill}}",
  "detail_skill_already_unlocked": "Al ontgrendeld",
  "detail_consume_book": "Verbruikt 1 boek",
  "detail_survivor_progress": "Progressie overlevende",
  "detail_survivor_level": "Niveau {{level}}",
  "detail_survivor_xp": "XP {{current}}/{{required}}",
  "detail_survivor_max_level": "Maxniveau bereikt",
  "workstation_open_recipes": "Open recepten",
  "detail_not_found": "Niet gevonden.",
  "detail_back": "Terug",
  "detail_needs": "Behoeften",
  "detail_skills": "Vaardigheden",
  "detail_loadout": "Uitrusting",
  "detail_expedition_cost": "Tochtenkosten",
  "detail_loadout_note": "Wapens komen uit je voorraad; uitrusten haalt er één uit en leg je hem terug bij het afdoen.",
  "detail_weapon_equip": "Uitrusten",
  "detail_weapon_swap": "Wisselen",
  "detail_weapon_unequip": "Terug naar voorraad",
  "detail_weapon_sheet_title": "Wapen uitrusten vanuit voorraad",
  "detail_weapon_sheet_note": "Kies een wapen en bekijk de schadeverandering.",
  "detail_weapon_sheet_empty": "Geen wapens in voorraad.",
  "detail_weapon_bow_locked": "Vereist Boogschieten (leer via een boek).",
  "detail_weapon_effective": "{{effective}} schade (basis {{base}}, vaardigheidsmultiplier)",
  "ws_assign_kitchen_need_cooking": "Niemand heeft Koken. Zoek een kookboek op een tocht.",
  "detail_cost_discount_note": "Kortingen volgen uit Sluw en Kracht.",
  "detail_send": "Stuur op pad",
  "detail_unavailable": "Niet beschikbaar",
  "cost_abbr_h": "H",
  "cost_abbr_d": "D",
  "cost_abbr_m": "M",
  "hideout_tier_label": "Kamp",
  "hideout_relocate_section": "Schuilplaats verplaatsen",
  "hideout_relocate_progress": "Tochten voltooid: {{current}} / {{need}} vereist",
  "hideout_relocate_btn_short": "Schuilplaats verplaatsen",
  "ws_detail_level_line": "Niveau {{level}} / max {{cap}} (deze locatie)",
  "ws_detail_unbuilt": "Niet gebouwd",
  "ws_detail_build_section": "Eerste bouw",
  "ws_detail_build_cta": "Station bouwen",
  "ws_detail_build_tier_gate": "Vereist schuilplaatsniveau: {{tier}}",
  "ws_detail_upgrade_section": "Verbeteren",
  "ws_detail_upgrade_cta": "Station upgraden",
  "ws_detail_upgrade_max_tier": "Maximum voor deze schuilplaats — verhuis om hoger te gaan.",
  "ws_detail_upgrade_next": "Volgende: niveau {{level}}",
  "ws_detail_no_upgrade": "Geen verdere upgrade",
  "ws_detail_assign_section": "Toewijzing",
  "ws_detail_assigned": "Toegewezen",
  "ws_detail_working": "Werkt",
  "ws_detail_unassigned": "Niemand toegewezen",
  "ws_detail_assign_button": "Werknemer kiezen of wijzigen",
  "ws_detail_assign_placeholder": "Wijs iemand toe voor rolbonussen.",
  "ws_detail_offers_section": "Wat dit station biedt",
  "ws_detail_offers_empty": "Geen samenvatting beschikbaar.",
  "ws_detail_offer_stash_bullet": "Voorraadstacklimiet op dit niveau: ~{{cap}} unieke stapels.",
  "ws_detail_offer_stash_next": "Volgend stationniveau ({{level}}): ~{{cap}} stapels.",
  "ws_detail_offer_hub_bullet": "Tot {{count}} expedities tegelijk vanuit deze schuilplaats.",
  "ws_detail_offer_restore_bullet": "Verzorging herstelt {{need}} in de loop van de tijd — ongeveer +{{amount}} per bezoek (gereedschap & werknemer meegerekend).",
  "ws_detail_offer_restore_heal_bullet": "Legacy — gebruik de trauma-afdeling voor blessures.",
  "ws_detail_offer_injury_bullet": "Gebruik medicijnen om getimede verwondingen te stabiliseren.",
  "ws_detail_offer_lodging_roster": "Onderdak verhoogt de rosterlimiet naar {{cap}} overlevenden.",
  "ws_detail_offer_lodging_rest": "{{used}}/{{max}} bedden · +{{rate}} energie/min tijdens rust.",
  "ws_detail_offer_broadcast": "Tot {{max}} openstaande radio-contacten. ~{{minutes}} min tussen contacten met een operator.",
  "ws_detail_lodging_section": "Rust",
  "ws_detail_lodging_leave": "Verlaat bed",
  "ws_detail_lodging_rest_here": "Rust hier",
  "ws_detail_lodging_can_rest": "Overlevenden die hier kunnen rusten",
  "ws_detail_injury_empty": "Niemand heeft nu behandeling nodig.",
  "ws_detail_broadcast_pending_empty": "Geen openstaande radiocontacten.",
  "ws_detail_injury_section": "Blessures",
  "ws_detail_broadcast_section": "Radio-contacten",
  "ws_detail_broadcast_accept": "Werven",
  "ws_detail_broadcast_deny": "Weggisten",
  "ws_detail_broadcast_roster_note": "Team {{current}}/{{cap}}",
  "ws_detail_offer_restore_kitchen_bullet": "Eten bij het kampvuur herstelt ongeveer {{amount}} honger.",
  "ws_detail_offer_restore_well_bullet": "Drinken bij het waterpunt herstelt ongeveer {{amount}} dorst.",
  "ws_detail_offer_passive_regen_bullet": "Passief herstel vult {{need}} met {{rate}} per minuut voor overlevers die niet op missie zijn.",
  "ws_detail_offer_generator_bullet": "Produceert voorraden elke ~{{minutes}} min (maximaal {{cap}} claimbare items).",
  "ws_detail_offer_generator_worker_required": "Wijs een overlever toe om generatie te starten.",
  "ws_detail_offer_generator_worker_skill": "De vaardigheid van de toegewezen overlever verlaagt de productiecooldown.",
  "ws_detail_offer_craft_bullet": "Maak van schroot uitrusting en voorraden via recepten.",
  "ws_detail_generator_section": "Gegenereerde voorraden",
  "ws_detail_generator_empty": "Nog geen items gegenereerd.",
  "ws_detail_generator_needs_worker": "Wijs een overlever toe om items te genereren.",
  "ws_detail_generator_claim_all": "Alles claimen",
  "ws_detail_generator_hint": "{{count}} / {{cap}} claimbare items opgeslagen. Huidige cooldown: ~{{minutes}} min.",
  "ws_detail_tools_section": "Gereedschap en extras",
  "ws_detail_tool_installed": "Geïnstalleerd",
  "ws_detail_tool_install": "Installeren",
  "ws_detail_tool_effect_restore": "+{{n}} bonusherstel bij verzorging",
  "ws_detail_tool_effect_craft": "~{{pct}}% snellere crafts",
  "ws_detail_actions": "Acties",
  "ws_detail_stash_cap": "Voorraadstacklimiet op dit niveau: ~{{cap}} unieke stapels.",
  "ws_detail_stash_cap_arrow": "Upgrade verhoogt limiet: {{from}} → {{to}} stapels.",
  "ws_detail_care_section": "Verzorging",
  "ws_detail_care_section_kitchen": "Honger herstellen (kost 1 voedsel)",
  "ws_detail_care_section_well": "Dorst herstellen (kost 1 water)",
  "ws_detail_gem_heal_cta_full": "VOLLEDIG HERSTEL ({{cost}} ◆)",
  "ws_detail_gem_heal_cta_infirmary": "ALLE BLESSURES WEG ({{cost}} ◆)",
  "ws_detail_gem_heal_need_gems": "Vereist {{cost}} ◆.",
  "ws_detail_gem_heal_cooldown": "Edelsteenheal op cooldown: nog {{minutes}} min.",
  "ws_detail_restore_preview": "Herstelt +{{amount}} (met gereedschap en persoon)",
  "ws_detail_quote_not_hungry": "Ik heb geen honger",
  "ws_detail_quote_not_thirsty": "Ik heb geen dorst",
  "ws_detail_quote_not_hurt": "Ik heb geen behandeling nodig",
  "ws_detail_craft_section": "Crafting",
  "ws_detail_craft_preview": "Recepten maken van schroot uitrusting; hoger niveau & gereedschap versnelt dit.",
  "ws_detail_assign_sheet_title": "Wie werkt hier?",
  "ws_detail_assign_clear": "Toewijzing wissen",
  "ws_upgrade_title": "Upgrade naar niveau {{level}}",
  "ws_upgrade_requires_tier": "Vereist schuilplaats minstens",
  "ws_upgrade_tier_blocked": "Verhuis naar een betere schuilplaats om dit te halen.",
  "ws_upgrade_cap_blocked": "Dit station zit op het maximum voor je huidige locatie.",
  "ws_upgrade_costs": "Kosten",
  "ws_upgrade_confirm": "Upgrade bevestigen",
  "ws_upgrade_cannot": "Kan niet upgraden (vereisten of materiaal)",
  "sync_err_stale_session": "Je account staat niet meer in de database — dit gebeurt vaak na een DB-reset terwijl je nog ingelogd bent. Meld je af en log opnieuw in met Google.",
  "sync_err_generic": "Synchroniseren mislukt.",
  "exp_heading_returned": "Teruggekeerd",
  "exp_click_to_collect": "Klik om op te halen",
  "exp_report_ready": "Tochtrapport klaar",
  "exp_report_ready_with_name": "Tochtrapport klaar · {{name}}",
  "exp_returned_from_location": "{{name}} keerde terug van {{location}}",
  "exp_trip_report_label": "Tochtrapport",
  "exp_trip_report_title": "Expeditie-opbrengst claimen",
  "exp_trip_report_survivor": "Verkenner: {{name}}",
  "exp_trip_report_now": "zojuist",
  "exp_trip_report_needs": "Behoefteverandering",
  "exp_trip_report_loot": "Gevonden items",
  "exp_trip_report_completed_title": "Voltooide tocht naar {{location}}",
  "exp_trip_report_loot_yield_team_label": "Team",
  "exp_trip_report_loot_yield_vehicle_label": "Voertuig",
  "exp_trip_report_loot_needs_warning": "Let op de behoeften van je overlevende",
  "exp_trip_report_keep": "Bewaren",
  "exp_trip_report_discarded": "Weggooien",
  "exp_trip_report_found_survivor": "Mogelijke overlevende gevonden",
  "exp_trip_report_recruit_yes": "Recruit",
  "exp_trip_report_recruit_no": "Send away",
  "exp_trip_report_roster_full": "Schuilplaats vol ({{cap}} mensen). Stuur ze weg of breid onderdak uit.",
  "exp_trip_report_complete": "Voltooien",
  "exp_trip_report_location_unlocked_title": "Locatie ontgrendeld",
  "exp_trip_report_location_unlocked_item": "Ontgrendeld: {{location}}",
  "exp_trip_report_location_unlocked_popup_title": "LOCATIE ONTGRENDELD",
  "exp_trip_report_location_unlocked_popup_location": "{{location}}",
  "exp_trip_report_location_unlocked_popup_confirm": "Bevestigen",
  "exp_trip_report_found_vehicle": "Voertuig gevonden",
  "exp_trip_report_vehicle_no_garage": "Geen garage gebouwd — kan voertuig niet opslaan.",
  "exp_trip_report_vehicle_garage_full": "Niet genoeg parkeerplek voor dit voertuig — maak eerst ruimte.",
  "exp_trip_report_vehicle_scrap_hint": "Hub → Garage: sloop een geparkeerd voertuig voor plek. Je kunt dit rapport afsluiten zonder de vondst op te slaan.",
  "exp_trip_report_manage_garage": "Garage beheren",
  "exp_trip_report_manage_garage_title": "Maak parkeerplek vrij",
  "exp_trip_report_manage_garage_body": "Sloop een voertuig dat niet op een tocht is. Als er genoeg plek is, kun je deze vondst hieronder opslaan.",
  "exp_trip_report_manage_garage_close": "Klaar",
  "exp_trip_report_manage_garage_scrap": "Sloop…",
  "exp_trip_report_manage_garage_confirm_scrap": "Bevestig slopen",
  "exp_trip_report_vehicle_all_on_mission": "Alle voertuigen in de garage zijn op een tocht — wacht op terugkeer of rond af zonder op te slaan.",
  "exp_trip_report_vehicle_store": "Opslaan: ja",
  "exp_trip_report_vehicle_discard": "Opslaan: nee",
  "garage_section_title": "Garage",
  "garage_empty": "Geen voertuigen in de garage. Zoek er een op een tocht.",
  "garage_slots_line": "Parkeerplekken: {{used}} / {{max}}",
  "garage_slots_legend": "Klein = 1 plek · Middel = 2 · Groot = 4. Verbeter de garage voor meer ruimte.",
  "garage_over_capacity_hint": "Te vol — sloop iets in de Hub om balans te brengen.",
  "garage_scrap_btn": "Sloop",
  "garage_scrap_popup_title": "Voertuig slopen",
  "garage_scrap_yield_label": "Onderdelen:",
  "garage_scrap_confirm": "Bevestig slopen",
  "garage_scrap_cancel": "Annuleer",
  "garage_repair_btn": "Repareer ({{scrap}} schroot → +{{pct}}%)",
  "garage_durability": "Staat",
  "assign_vehicle_label": "Neem een voertuig mee",
  "assign_vehicle_none": "Geen voertuig",
  "assign_vehicle_seat_hint": "Neem je een voertuig mee, dan moet er voor iedereen plek zijn.",
  "assign_not_enough_seats": "NIET GENOEG ZITPLAATSEN",
  "assign_vehicle_passenger_seats": "{{count}} zitplaatsen",
  "exp_card_away_team": "{{leader}} +{{count}} onderweg",
  "exp_trip_report_team": "{{leader}} +{{count}} meer",
  "quests_vehicle_tag": "Voertuigen",
  "quest_vehicle_title": "Wielen voor de wildernis",
  "quest_vehicle_body": "Na het Den Bosch-gatewayplan: het gerucht over een oude fiets op de verlaten boerderij. Wielen maken tochten sneller en buit zwaarder — als je garageplek hebt.",
  "quest_phase_build_garage": "Bouw het Garage-werkstation in de Hub.",
  "quest_phase_farm_expedition": "Doe een expeditie naar de Verlaten boerderij — er zou iets te vinden zijn.",
  "quest_garage_recheck": "Garage controleren",
  "quest_vehicle_complete": "Eerste voertuig veiliggesteld. De garage is open.",
  "quest_vehicle_reward": "Fietsen kunnen nu op elke expeditie verschijnen. Voertuigen geven een buitbonus, gebruiken garageplek naar formaat, slijten per tocht — repareer met schroot of sloop voor onderdelen.",
  "quest_cooking_skill_tag": "Schuilplaats",
  "quest_cooking_skill_title": "Eerste kok in de keuken",
  "quest_cooking_skill_body": "Een derde paar handen betekent dat het tijd is om te organiseren. Boeken leren vaardigheden — en een getrainde kok in de keuken maakt elke maaltijd meer waard.",
  "quest_cooking_phase_find_book": "Vind een exemplaar van Boek: Thuis koken",
  "quest_cooking_phase_learn_skill": "Leer een overlevende het koken aan",
  "quest_cooking_phase_assign_kitchen": "Wijs een kok toe aan het keukenwerkstation",
  "quest_cooking_complete": "De keuken heeft een kok. Maaltijden tellen nu meer.",
  "quest_cooking_reward": "Beloning: 20 kristallen.",
  "stash_book_teach": "Leer aan",
  "stash_book_teach_title": "Leer {{skill}} via {{item}}",
  "stash_book_teach_note": "Kies een overlevende om dit skill te leren. Het boek wordt verbruikt.",
  "stash_book_already_known": "Kent dit skill al",
  "quest_hideout_move_tag": "Schuilplaats",
  "quest_hideout_move_title": "Een betere basis vinden",
  "quest_hideout_move_body": "Het boskamp heeft zijn dienst bewezen, maar je hebt meer ruimte en betere faciliteiten nodig. Verken de verlaten boerderij, verplaats je schuilplaats naar een echte werkplek — en upgrade het Basisstation om er optimaal gebruik van te maken.",
  "quest_hideout_move_phase_farm_trip": "Voltooi een tocht naar de Verlaten boerderij",
  "quest_hideout_move_phase_relocate": "Gebruik de knop 'Schuilplaats verplaatsen' op het Basisstation",
  "quest_hideout_move_phase_upgrade_base": "Upgrade het Basisstation naar niveau 2",
  "quest_hideout_move_complete": "Je operatie heeft nu een echte basis.",
  "quest_hideout_move_reward": "Beloning: 20 kristallen. Je nieuwe schuilplaats ondersteunt hogere werkstationniveaus.",
  "journal_tab_quests": "Quests",
  "journal_tab_milestones": "Mijlpalen",
  "milestone_first_100_food_collected_title": "Hamsteraar",
  "milestone_first_100_food_collected_desc": "100 voedsel verzameld op tochten.",
  "milestone_first_den_bosch_trip_title": "Stadverkenner",
  "milestone_first_den_bosch_trip_desc": "Je eerste tocht naar 's-Hertogenbosch voltooid.",
  "milestone_first_5_crafts_title": "Klusser",
  "milestone_first_5_crafts_desc": "5 klusklussen voltooid.",
  "milestone_out_the_door_title": "Op Pad",
  "milestone_out_the_door_desc": "Je eerste team de veld ingestuurd.",
  "milestone_strength_in_numbers_title": "Samen Sterk",
  "milestone_strength_in_numbers_desc": "Een derde overlevende in je schuilplaats opgenomen.",
  "milestone_full_house_title": "Volzet",
  "milestone_full_house_desc": "Alle vijf beschikbare overlevenden gerekruteerd.",
  "milestone_on_four_wheels_title": "Op Wielen",
  "milestone_on_four_wheels_desc": "Je eerste voertuig — let op garageplek als je het meeneemt.",
  "milestone_new_home_title": "Nieuw Thuis",
  "milestone_new_home_desc": "Je schuilplaats voor het eerst verplaatst.",
  "milestone_signal_found_title": "Signaal Gevonden",
  "milestone_signal_found_desc": "Veldradio gebouwd — handig voor het zendstation en mijlpalen.",
  "milestone_water_bearer_title": "Waterdrager",
  "milestone_water_bearer_desc": "100 water verzameld op tochten.",
  "milestone_workshop_regular_title": "Vaste Klant",
  "milestone_workshop_regular_desc": "25 klusklussen voltooid.",
  "milestone_street_wise_title": "Straatwijs",
  "milestone_street_wise_desc": "10 tochten naar 's-Hertogenbosch voltooid.",
  "milestone_blooded_title": "Gehard",
  "milestone_blooded_desc": "Een overlevende gewond op tocht.",
  "milestone_progress_label": "Voortgang",
  "milestone_unlocked_toast": "Mijlpaal behaald: {{name}}",
  "milestone_locked_label": "Vergrendeld",
  "milestone_claim_button": "Beloning claimen",
  "milestone_claimed_label": "Beloning opgehaald",
  "tutorial_label": "Tutorial",
  "tutorial_next": "Begrepen",
  "tutorial_finish": "Aan de slag",
  "tutorial_hideout_resources_title": "Jouw schuilplaats",
  "tutorial_hideout_resources_body": "Houd hier overlevenden, voedsel, water, schroot en medicijnen bij. Raak je op, dan gaat het snel mis.",
  "tutorial_hideout_workstations_title": "Werkstations",
  "tutorial_hideout_workstations_body": "Bouw stations om ambachten en productie te ontgrendelen. Er komen meer beschikbaar naarmate je vordert.",
  "tutorial_nav_tabs_title": "Navigatie",
  "tutorial_nav_tabs_body": "Gebruik deze tabbladen om tussen de gebieden van je schuilplaats te wisselen.",
  "tutorial_survivors_list_title": "Jouw overlevenden",
  "tutorial_survivors_list_body": "Iedereen in je groep woont hier. Controleer hun status, behoeften en vaardigheden voordat je hen op pad stuurt.",
  "tutorial_stash_items_title": "De voorraad",
  "tutorial_stash_items_body": "Alles wat je vindt komt hier terecht. Je begint met wat eten en water — gebruik ze om honger en dorst te stillen na tochten.",
  "tutorial_expeditions_locations_title": "Expedities",
  "tutorial_expeditions_locations_body": "Stuur overlevenden op pad om te scavengeren. Verken locaties volledig om nieuwe gebieden met betere buit te ontgrendelen.",
  "tutorial_quests_quest_title": "Je eerste opdracht",
  "tutorial_quests_quest_body": "Opdrachten begeleiden je door het spel. Je eerste legt de basis uit — begin daar.",
  "tutorial_quests_milestones_title": "Mijlpalen",
  "tutorial_quests_milestones_body": "Bereik mijlpalen om edelstenen te verdienen. Claim ze hier wanneer ze vrijkomen.",
  "vehicle_detail_title": "Voertuig",
  "vehicle_detail_buffs": "Voordelen",
  "vehicle_detail_parts": "Onderdelen",
  "vehicle_detail_durability": "Duurzaamheid",
  "vehicle_detail_status": "Status",
  "vehicle_detail_on_trip": "Op tocht",
  "vehicle_detail_idle": "Inactief",
  "vehicle_detail_loot": "buit",
  "vehicle_detail_seat": "zitplaats",
  "vehicle_detail_trip_time_short": "reistijd",
  "vehicle_detail_wear_short": "slijtage",
  "vehicle_part_maxed": "Voluit",
  "vehicle_part_upgrade_cta": "Upgrade naar Lv {{level}}",
  "vehicle_part_upgrade_on_trip_disabled": "Upgrade tijdens tocht uitgeschakeld",
  "garage_auto_repair_hint": "Auto-reparatie: +{{rate}} duurzaamheid per minuut"
}
